console.debug((new Date).getFullYear() + ' (c) Ilyin Aleksey <alksily[at]outlook[dot]com>');

window.parseB64Code = (code) => {
    let div = document.createElement('div');
        div.innerHTML = code;
        
    return JSON.parse(decodeURIComponent(escape(atob(div.textContent || div.innerText || ''))));
};

window.getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    
    return Math.floor(Math.random() * (max - min)) + min;
};

//-----------------------------------------------------------------------
// Cloud Payments
(() => {
    let n, s;
    
    n = document.getElementsByTagName('script')[0];
    s = document.createElement('script');
    
    s.async = true;
    s.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments.js';
    n.parentNode.insertBefore(s, n);
})();

//-----------------------------------------------------------------------
// Toast
let autoCloseToast;

window.toastbox = (target, time) => {
    let a = document.getElementById(target);
    closeToastBox()
    setTimeout(() => {a.classList.add('show')}, 100);
    if (time) {
        time = time + 100;
        autoCloseToast = setTimeout(() => {
            closeToastBox()
        }, time);
    }
}
window.closeToastBox = () => {
    document.querySelectorAll('.toast-box').forEach(function (el) {
        el.classList.remove('show')
        clearTimeout(autoCloseToast)
    })
}

//-----------------------------------------------------------------------
// Polyfill
if (typeof String.prototype.replaceAll == "undefined") {
    String.prototype.replaceAll = function(match, replace) {
        return this.replace(new RegExp(match, 'g'), () => replace);
    }
}
